/**
 * Direcciones de las pantallas.
 *
 * Vive en su propio modulo, sin importar nada, a proposito: si se declarara en
 * `App.tsx`, la navegacion tendria que importar `App` y `App` tendria que
 * importar la navegacion. Ese ciclo se resuelve en tiempo de compilacion sin
 * quejarse y luego revienta en el navegador con un "undefined" al evaluar el
 * modulo, que es exactamente el tipo de fallo que no se ve venir.
 *
 * Las direcciones estan en español porque el usuario las ve en la barra del
 * navegador y al compartir un enlace.
 */

export const ROUTES = {
  pos: '/',
  dashboard: '/panel',
  intelligence: '/surtido',
  credit: '/credito',
  inventory: '/inventario',
  expenses: '/gastos',
  cash: '/caja',
  sales: '/ventas',
  staff: '/personal',
  stores: '/sucursales',
  /** Recorrido de demostracion. Publico a proposito: se ve sin iniciar sesion. */
  demo: '/demo',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
